import { Box, Button, makeStyles } from "@material-ui/core";
import React, { Fragment } from "react";
import titleButtonData from "./veggies/TitleButtonData";
import WhiteTriangle from "./veggies/white_triangle.png";
import GreenTriangle from "./veggies/greenTriangle.png";
const useStyles = makeStyles((theme) => ({
  sidebar: {
    width: "100%",
    height: "100%",
    backgroundColor: "rgb(232,232,232)",
    borderRadius: "5px",
    boxShadow: "2px 2px 10px 0 rgba(0,0,0, 0.2)",
    padding: "40px 25px",
    [theme.breakpoints.between("md", "md")]: {
      padding: "25px 15px",
    },
  },
  button: {
    width: "100%",
    height: "80px",

    marginBottom: "20px",
    fontWeight: "bold",
    fontSize: "18px",
    borderRadius: "5px",
    boxShadow: "2px 2px 10px 0 rgba(0,0,0, 0.2)",
    backgroundColor: "white",
    [theme.breakpoints.between("md", "md")]: {
      fontSize: "12px",
    },
  },
  buttonActive: {
    width: "100%",
    height: "80px",
    backgroundColor: theme.palette.primary.main,
    marginBottom: "20px",
    fontWeight: "bold",
    fontSize: "18px",
    borderRadius: "5px",
    boxShadow: "2px 2px 10px 0 rgba(0,0,0, 0.2)",
    [theme.breakpoints.between("md", "md")]: {
      fontSize: "12px",
    },
  },
  left: {
    flexGrow: 1,
  },
  arrow: {
    marginLeft: "5px",
    marginRight: "5px",
  },
  imgFruit: {
    [theme.breakpoints.between("md", "md")]: {
      width: "14px",
      height: "auto",
    },
  },
}));

const Sidebar = ({ veggieItem, setVeggieItem }) => {
  // const [button, setButton] = useState(1);
  const classes = useStyles();
  return (
    <Box className={classes.sidebar}>
      {titleButtonData.map((btn) => {
        return (
          <Fragment key={btn.id}>
            <ItemButton
              id={btn._id}
              title={btn.title}
              logo={btn.logo}
              button={veggieItem}
              setButton={() => setVeggieItem(btn._id, btn._id)}
            />
          </Fragment>
        );
      })}
    </Box>
  );
};

export default Sidebar;

const ItemButton = ({ button, setButton, title, id }) => {
  const classes = useStyles();
  const contained = id === button ? "primary" : "default";
  return (
    <Button
      onClick={setButton}
      variant="contained"
      color={contained}
      className={`${id === button ? classes.buttonActive : classes.button}`}
    >
      <div className={classes.left} />

      {title}
      {button === id ? (
        <img
          src={WhiteTriangle}
          className={classes.arrow}
          alt="white triangle"
        />
      ) : (
        <img src={GreenTriangle} className={classes.arrow} alt="triangle" />
      )}
    </Button>
  );
};
